<template>
  <VanDialog v-model:show="store.showScoreSliderModal">
    <template #title>
      <div class="text-center text-base font-bold">
        {{ $t("ConfirmModal.rating") }}
      </div>
    </template>

    <VanCellGroup inset>
      <VanField
        v-model.number="store.modalScore"
        class="text-center my-2"
        type="number"
      />
    </VanCellGroup>

    <div class="flex gap-4 py-4 px-6">
      <span>-100</span>
      <VanSlider v-model="store.modalScore" :max="100" :min="-100">
        <template #button>
          <div
            class="w-[26px] text-white text-xs leading-[18px] text-center bg-primary rounded-[100px]"
          >
            {{
              store.modalScore >= 0 ? `+${store.modalScore}` : store.modalScore
            }}
          </div>
        </template>
      </VanSlider>
      <span>+100</span>
    </div>

    <template #footer>
      <div class="flex justify-center py-4">
        <button class="btn btn-primary btn-sm mr-2" @click="clickConfirm">
          {{ t("Buttons.confirm") }}
        </button>

        <button class="btn btn-sm" @click="store.showScoreSliderModal = false">
          {{ t(`story.g.cancel`) }}
        </button>
      </div>
    </template>
  </VanDialog>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { watch } from "vue";
import { useI18n } from "vue-i18n";

const store = useGalGameEditor();
const { t } = useI18n();

const emit = defineEmits(["update:score"]);

watch(
  () => store.modalScore,
  (val) => {
    if (val <= -100) {
      store.modalScore = -100;
    } else if (val >= 100) {
      store.modalScore = 100;
    }
  }
);

const clickConfirm = async () => {
  // const { activeDialogOption } = store;
  // store.saveLoading = true;
  // activeDialogOption.score = store.modalScore;
  // store.saveDialogOption();
  store.showScoreSliderModal = false;
  emit("update:score", store.modalScore);
  // store.saveLoading = false;
};
</script>
